import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogTitle,
} from "../../ui/AlertDialog/AlertDialog";
import { t } from "i18next";
import React, { useEffect } from "react";
import { useFetch } from "../../hooks/useFetch";
import { Button } from "../../ui/Button";
import { useAppStore } from "../../stores/RootStore";
import { useNavigate } from "react-router-dom";
import ErrorsBlock from "../../components/errors/ErrorsBlock";

type Props = {
  id: string;
  isDeleteOpen: boolean;
  closeModal: Function;
};

const DeleteDivision = ({ id, isDeleteOpen, closeModal }: Props) => {
  const [{ response: itemDeleteResponse, isLoading: itemDeleteIsLoading, error: itemDeleteError }, doFetchItemDelete] =
    useFetch(`/directories/divisions/${id}`);

  const setDivisions = useAppStore((store) => store.setDivisions);
  const divisions = useAppStore((store) => store.divisions);

  const deleteType = () => {
    setDivisions(divisions?.filter((division) => division.id != id)!);
  };

  const navigate = useNavigate();
  useEffect(() => {
    if (itemDeleteResponse) {
      deleteType();
      navigate("..", { relative: "path" });
      closeModal();
    }
  }, [itemDeleteResponse]);

  const onDelete = () => {
    doFetchItemDelete({
      method: "DELETE",
    });
  };

  const openStateChange = () => {
    if (isDeleteOpen) closeModal();
  };

  return (
    <AlertDialog open={isDeleteOpen} onOpenChange={openStateChange}>
      <AlertDialogContent style={{ maxWidth: 450 }}>
        <AlertDialogTitle>Удалить подразделение</AlertDialogTitle>
        <AlertDialogDescription>Вы уверены, что хотите удалить подразделение?</AlertDialogDescription>
        <div className="flex justify-between mt-4">
          <Button variant={"destructive"} size={"md"} className="px-3" onClick={onDelete}>
            {t("delete")}
          </Button>
          <AlertDialogCancel className="h-8">{t("cancel")}</AlertDialogCancel>
        </div>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default DeleteDivision;
